import { Link } from "@mui/material";
import { CoreModal, CoreModalDescription } from "../../../core";
import i18nPackage from "../../../i18n/i18n";
import { Trans } from "react-i18next";

export function IncognitoWarningModal({ open, onClose }: { open: boolean; onClose: () => void }) {
	const ariaLabel = i18nPackage.t("editQuizPage.configurationStep.incognitoModal.ariaLabel");
	return (
		<CoreModal
			onClose={onClose}
			open={open}
			title={i18nPackage.t("editQuizPage.configurationStep.incognitoModal.title")}
			buttons={[
				{
					text: i18nPackage.t("editQuizPage.configurationStep.incognitoModal.ok"),
					onClick: onClose,
					"aria-label": i18nPackage.t("editQuizPage.configurationStep.incognitoModal.closeButtonAriaLabel"),
				},
			]}
			maxWidth="750px"
		>
			<CoreModalDescription>
				{i18nPackage.t("editQuizPage.configurationStep.incognitoModal.description")}
			</CoreModalDescription>
			<br></br>
			<CoreModalDescription>
				<Trans
					i18nKey={"editQuizPage.configurationStep.incognitoModal.link"}
					i18n={i18nPackage}
					components={{
						a: (
							<Link
								href="https://support.yuja.com/hc/en-us/articles/25758832063895-Enabling-Incognito-Mode-for-the-Verity-Extension"
								target="_blank"
								rel="noreferrer"
								aria-label={ariaLabel}
							/>
						),
					}}
				/>
			</CoreModalDescription>
		</CoreModal>
	);
}
